import { TeamOutlined, UserAddOutlined } from '@ant-design/icons'
import type { ReactNode } from 'react'

import type { OrganisationInterface } from '@/types'

import AllOrganisations from '../AllOrganisations/AllOrganisations'
import OrganisationCreation from '../OrganisationCreation/OrganisationCreation'
import cn from './ClientActions.module.scss'

interface ClientActionsProps {
  isWideScreen: boolean
  canCreateOrganisation: boolean
  searchInput: ReactNode
  searchResults: ReactNode
  onChooseOrganisation: (organisation: OrganisationInterface) => void
}

function ClientActions({
  isWideScreen,
  canCreateOrganisation,
  searchInput,
  searchResults,
  onChooseOrganisation,
}: ClientActionsProps) {
  return (
    <div className={cn.clientActions}>
      {isWideScreen && (
        <div className={cn.clientSearch}>
          <div className={cn.searchField}>{searchInput}</div>
          <div className={cn.searchResults}>{searchResults}</div>
        </div>
      )}
      <AllOrganisations
        handleChooseOrganisation={onChooseOrganisation}
        trigger={{
          className: cn.iconButton,
          icon: <TeamOutlined />,
          label: 'Все клиенты',
        }}
      />
      {isWideScreen && canCreateOrganisation && (
        <OrganisationCreation
          trigger={{
            className: cn.iconButton,
            icon: <UserAddOutlined />,
            label: 'Зарегистрировать клиента',
          }}
        />
      )}
    </div>
  )
}

export default ClientActions
